import { NgModule } from '@angular/core';

import { BetslipLinearTrackingService } from './services/betslip-linear-tracking.service';

@NgModule({
    providers: [BetslipLinearTrackingService],
})
export default class BetslipDigitalTrackingModule {}
